import React from 'react';
import { ShieldCheck, Lock } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="section-container relative" data-id="element-119">
      <div className="absolute inset-0 bg-sage-dark/5 transform -skew-y-3 z-0" data-id="element-120"></div>

      <div className="text-container relative z-10" data-id="element-121">
        <div className="bg-white rounded-3xl shadow-xl border-2 border-gold p-8 md:p-12 text-center max-w-2xl mx-auto" data-id="element-122">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal-dark" data-id="element-123">
            Recupera tu confianza
          </h2>
          <p className="text-lg md:text-xl text-charcoal-light mb-8" data-id="element-124">
            Y vuelve a usar la ropa que amas por menos de lo que cuesta una cena
            fuera de casa. Accede hoy mismo al protocolo completo por un precio
            especial de lanzamiento.
          </p>

          <div className="mb-8 flex flex-col items-center justify-center" data-id="element-125">
            <span className="text-gray-400 line-through text-2xl mb-2 font-sans" data-id="element-126">
              Precio Regular: $19.99 USD
            </span>
            <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-127">
              <span className="text-xl font-bold text-sage-dark uppercase tracking-wider" data-id="element-128">
                Hoy solo:
              </span>
              <span className="text-6xl md:text-7xl font-bold text-gold font-playfair" data-id="element-129">
                $6,39 <span className="text-2xl" data-id="element-130">USD</span>
              </span>
              <span className="bg-red-500 text-white text-sm md:text-base font-bold px-3 py-1.5 rounded-full uppercase tracking-wide shadow-md" data-id="element-131">
                68% OFF
              </span>
            </div>
          </div>

          <a href="https://habitosqueviven.com/cart/44099700949127:1" target="_blank" rel="noopener noreferrer" className="btn-primary w-full py-5 text-xl md:text-2xl shadow-gold/20 shadow-xl mb-6 animate-pulse hover:animate-none" onClick={() => {
          if (typeof window.fbq === 'function') {
            window.fbq('track', 'InitiateCheckout');
          }
        }} data-id="element-132">
            ¡SÍ, QUIERO MI VIENTRE PLANO AHORA!
          </a>

          <div className="flex flex-col items-center justify-center gap-3 text-sm text-charcoal-light bg-cream/50 p-4 rounded-xl" data-id="element-133">
            <p className="flex items-center gap-2 font-medium" data-id="element-134">
              <Lock className="w-4 h-4 text-sage-dark" data-id="element-135" />
              Acceso inmediato tras tu compra segura.
            </p>
            <p className="flex items-center gap-2" data-id="element-136">
              <ShieldCheck className="w-4 h-4 text-sage-dark" data-id="element-137" />
              Pago protegido con encriptación de 256 bits.
            </p>
          </div>
        </div>
      </div>
    </section>;
}